import React, { useEffect, useState } from 'react';
import Typography from 'src/components/Typography';
import { Flex } from 'src/components/UI/Flex';
import { Select } from 'src/components/UI/Select/Select';
import { safeGetFromLocalStorage, safeSetInLocalStorage } from 'src/helpers/window';
import { useAssistantContext } from 'src/providers/AssistantProvider';
import { useFeedbackContext } from 'src/providers/FeedbackProvider';
import { usePrescriberContext } from 'src/providers/PrescriberProvider';
import { AssistantService, DoctorAssistantData } from 'src/services/AssistantService';

export default function AssistantLinkSelect() {
  const { setPrescriberId, prescriberId } = usePrescriberContext();
  const { assistantId } = useAssistantContext();
  const { openToast } = useFeedbackContext();
  const [doctors, setDoctors] = useState<DoctorAssistantData[]>([]);

  const handleSelectDoctor = (data: React.ChangeEvent<HTMLSelectElement>) => {
    setPrescriberId(data.target.value);
    safeSetInLocalStorage('selectedPrescriberId', data.target.value);
  };

  useEffect(() => {
    const run = async () => {
      try {
        if (!assistantId) return;
        const data = await AssistantService.getDoctors();

        setDoctors(data.prescribers);

        if (data.prescribers.length === 1) {
          setPrescriberId(data.prescribers[0].prescriber._id);
        }

        const selectedPrescriberId = safeGetFromLocalStorage('selectedPrescriberId');
        if (!selectedPrescriberId) return;

        setPrescriberId(safeGetFromLocalStorage('selectedPrescriberId'));
      } catch (error) {
        openToast('Erro ao buscar medicos conectados a esta conta, tente novamente mais tarde.', {
          type: 'error',
          duration: 2000,
        });
      }
    };

    run();
  }, [openToast, assistantId, setPrescriberId]);

  return (
    <Flex
      bg={'secondary.50'}
      p={'10px'}
      borderRadius={'15px'}
      w={'300px'}
      justifyContent={'center'}
      alignItems={'center'}
    >
      <Typography model="body" size={'small'} weight="bold" textAlign={'left'}>
        VOCÊ ESTÁ EDITANDO OS PACIENTES DE:
      </Typography>
      <Select
        h={'45px'}
        m={0}
        p={0}
        value={prescriberId ?? ''}
        placeholder={'Selecione uma opção'}
        onChange={handleSelectDoctor}
      >
        {doctors.map((item) => (
          <option value={item.prescriber._id}>{item.prescriber.fullName}</option>
        ))}
      </Select>
    </Flex>
  );
}
